/** localStorage key holding the reader's chosen layout, which follows them from page to
    page and across reloads. */
export const MARKET_VIEW_STORAGE_KEY = 'marketView'

export const MARKET_VIEW = {
  CARD: 'card',
  LIST: 'list',
}

/**
 * Which kind of row the list renders. Fixtures carry match data — kickoff, sides, score —
 * and read in kickoff order; every other market gets the generic row.
 */
export const LIST_VIEW_KIND = {
  MARKETS: 'markets',
  FIXTURES: 'fixtures',
}

/** Anything but an explicit `list` falls back to the card grid. */
export function parseMarketView(value) {
  return value === MARKET_VIEW.LIST ? MARKET_VIEW.LIST : MARKET_VIEW.CARD
}

/**
 * The layout the reader last chose, or the card grid: on the server, in a browser with
 * storage blocked, or before any choice was made.
 */
export function readStoredMarketView() {
  if (typeof window === 'undefined') return MARKET_VIEW.CARD
  try {
    return parseMarketView(window.localStorage.getItem(MARKET_VIEW_STORAGE_KEY))
  } catch {
    return MARKET_VIEW.CARD
  }
}

/** Keeps the chosen layout for the next page and the next visit. Storage that refuses is
    not an error: the choice still holds for this page. */
export function storeMarketView(view) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(MARKET_VIEW_STORAGE_KEY, parseMarketView(view))
  } catch {
    /* storage unavailable */
  }
}
